module.exports = __webpack_public_path__ + "img/presentation-plug.b62e6819.jpg";